import React, { useCallback, useState } from "react";
import { Col, Form, Modal, Space, Spin } from "antd";
import Title from "antd/lib/typography/Title";
import { linkTSRToCustomers } from "utils/api";
import CustomButton from "components/Common/buttons/CustomButton";
import { errorMessage, successMessage } from "components/Common/responses/message";
import NGIForm from "components/Common/form/NGIForm";
import NGIFormItem from "components/Common/form/NGIFormItem";
import { useSelector } from "react-redux";
import { TSRSelector } from "store/TSR/selectors";
import { AUTH_USER, USER_ROLES } from "utils/constants";
import TSRSelect from "components/Common/components/TSRSelect";

const MultipleLinkTSRModal = ({ onClose, customerIds, onUpdate }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoader] = useState(false);
  const { TSRList } = useSelector(TSRSelector);

  const handleCancel = useCallback(() => onClose(), [onClose]);

  const handleSave = useCallback(() => {
    const { technician, growthTechnician } = form.getFieldsValue();
    if (technician && growthTechnician && customerIds.length) {
      setLoader(true);
      const selectedTechnician = TSRList.find(item => item.id === technician);
      const selectedGrowthTechnician = TSRList.find(item => item.id === growthTechnician);
      linkTSRToCustomers({
        customerIds,
        technician: selectedTechnician.email,
        technicianName: selectedTechnician.name,
        growthTechnician: selectedGrowthTechnician.email,
        growthTechnicianName: selectedGrowthTechnician.name,
      })
        .then(() => {
          setTimeout(() => {
            successMessage("Customers were linked with the new TSR successfully");
            setLoader(false);
            onUpdate();
            onClose();
          }, 2000);
        })
        .catch(() => {
          errorMessage("Customers linking process is failed! Please check selected customers or TSR.");
          setLoader(false);
        });
    }
  }, [onUpdate, form, customerIds, TSRList]);

  return (
    <Modal open={true} title="Multiple link customers to TSR" closable={false} onCancel={handleCancel} footer={[]}>
      <Spin spinning={isLoading}>
        <NGIForm name="multipleLinkCustomersToTSR" form={form} onFinish={handleSave}>
          <Col span={24}>
            <Title level={5}>Growth TSR</Title>
            <NGIFormItem name="growthTechnician" rules={[{ required: true, message: "Please select Growth TSR" }]}>
              <TSRSelect
                showSearch
                filterBy={{
                  field: "team",
                  value: ["Growth"],
                }}
                initialList={TSRList.filter(item => item.depot === AUTH_USER()?.depotName && item.team === "Growth")}
                roles={[USER_ROLES.MMT, USER_ROLES.TECHNICIANS, USER_ROLES.MTSR, USER_ROLES.MDSC]}
                depot={AUTH_USER()?.depotName}
              />
            </NGIFormItem>
          </Col>
          <Col span={24}>
            <Title level={5}>Maintenance TSR</Title>
            <NGIFormItem name="technician" rules={[{ required: true, message: "Please select Maintenance TSR" }]}>
              <TSRSelect
                showSearch
                filterBy={{
                  field: "team",
                  value: ["Maintenance"],
                }}
                initialList={TSRList.filter(
                  item => item.depot === AUTH_USER()?.depotName && item.team === "Maintenance"
                )}
                roles={[USER_ROLES.MMT, USER_ROLES.TECHNICIANS, USER_ROLES.MTSR, USER_ROLES.MDSC]}
                depot={AUTH_USER()?.depotName}
              />
            </NGIFormItem>
          </Col>
          <Space>
            <CustomButton onClick={handleCancel} type="primary" color="outlined" size="small" text="Cancel" />
            <CustomButton htmlType="submit" type="primary" size="small" text="Save" />
          </Space>
        </NGIForm>
      </Spin>
    </Modal>
  );
};

export default MultipleLinkTSRModal;
